<template>
  <div class="transfer">
    <h1 class="seo-title">{{ seoHeading }}</h1>
    <div class="wrapper">
      <Navigation />
    </div>
    <Loader v-if="loading" />
    <keep-alive>
      <TransferMainForm
        v-if="currentTransfer === 'MainForm'"
        @changeModal="changeTransfer"
        @submitGift="submitGift"
        @submitPack="submitPack"
      />
    </keep-alive>
    <!-- keep-alive, чтобы возврат по «Назад» не стирал введённый ник и
         выбранного персонажа: компонент держит их в своём состоянии и из
         родителя не восстанавливается (RBXGD-1110). Тот же приём, что уже
         применён к MainForm и SuperPassGames. -->
    <keep-alive>
      <TransferCharacters
        v-if="currentTransfer === 'TransferCharacters'"
        :is-super-pass="data.superPass"
        :is-packs="data.packs"
        :data="data"
        @changeModal="changeTransfer"
      />
    </keep-alive>
    <PacksPayment
      v-if="currentTransfer === 'PacksPayment'"
      :pack="packWithNickname"
      @changeModal="changeTransfer"
      :sub-step="paymentSubStep"
      @subStep="paymentSubStep = $event"
    />
    <SuperPassTimeInfo v-if="currentTransfer === 'SuperPassTimeInfo'" @changeModal="changeTransfer" />
    <SuperPassStockInfo v-if="currentTransfer === 'SuperPassStockInfo'" @changeModal="changeTransfer" />
    <keep-alive>
      <SuperPassGames v-if="currentTransfer === 'SuperPassGames'" @changeModal="changeTransfer" :data="data" />
    </keep-alive>
    <SuperPassPasses v-if="currentTransfer === 'SuperPassPasses'" @changeModal="changeTransfer" :game="data.game" />
    <SuperPassPurchase
      v-if="currentTransfer === 'SuperPassPurchase'"
      @changeModal="changeTransfer"
      :data="data"
      :game="data.game"
      :pass="data.pass"
    />
    <TransferPrivatPlace
      v-if="currentTransfer === 'TransferPrivatPlace'"
      :robloxUserId="data.robloxUserId"
      :data="data"
      @changeModal="changeTransfer"
    />
    <TransferInstructionGamepass
      v-if="currentTransfer === 'TransferInstructionGamepass'"
      :data="data"
      @changeModal="changeTransfer"
    />
    <OrderConfirmation v-if="currentTransfer === 'OrderConfirmation'" @changeModal="changeTransfer" :data="data" />
    <TransferPaymentMethod
      v-if="currentTransfer === 'TransferPaymentMethod' && !data.superPass"
      @changeModal="changeTransfer"
      :isTransferOrSuperPass="true"
      :sub-step="paymentSubStep"
      @subStep="paymentSubStep = $event"
    />
    <SuperPassPaymentMethod
      v-if="currentTransfer === 'TransferPaymentMethod' && data.superPass"
      @changeModal="changeTransfer"
      :data="data"
      :game="data.game"
      :pass="data.pass"
      :sub-step="paymentSubStep"
      @subStep="paymentSubStep = $event"
    />
    <GiftPaymentMethod
      v-if="currentTransfer === 'GiftPaymentMethod'"
      :gift="data.gift"
      @changeModal="changeTransfer"
      :sub-step="paymentSubStep"
      @subStep="paymentSubStep = $event"
    />
    <SignIn
      v-if="currentTransfer === 'SignIn'"
      isStep
      :is-super-pass="data.superPass"
      @close="$router.push('/')"
      @back="signInBack"
      @success="signInSuccess"
      @createAccount="currentTransfer = 'SignUp'"
    />
    <SignUp
      v-if="currentTransfer === 'SignUp'"
      isStep
      :is-super-pass="data.superPass"
      @close="$router.push('/')"
      @back="currentTransfer = 'SignIn'"
      @success="currentTransfer = 'OrderConfirmation'"
    />
    <Approved v-if="currentTransfer === 'TransferApproved'" @changeModal="changeTransfer" :data="data" />
    <OrderSuccesful v-if="currentTransfer === 'TransferOrderSuccesful'" @changeModal="changeTransfer" :data="data" />
  </div>
</template>

<script>
import Navigation from '@/components/Navigation/Navigation'
import TransferMainForm from '@/components/Transfer/transferMainForm/TransferMainForm'
import TransferCharacters from '@/components/Transfer/transferCharacters/TransferCharacters'
import TransferPrivatPlace from '@/components/Transfer/transferPrivatPlace/TransferPrivatPlace'
import TransferInstructionGamepass from '@/components/Transfer/transferInstructionGamepass/TransferInstructionGamepass'
import OrderConfirmation from '@/components/Transfer/orderConfirmation/OrderConfirmation'
import TransferPaymentMethod from '@/components/Transfer/transferPaymentMethod/TransferPaymentMethod'

import Approved from '@/components/Transfer/transferApproved/Approved'
import OrderSuccesful from '@/components/Transfer/transferOrderSuccesful/OrderSuccesful'
import Loader from '@/components/LoaderBar/LoaderBar.vue'
import SignIn from '@/components/SignIn/SignIn.vue'
import SignUp from '@/components/SignUp/SignUp.vue'
import SuperPassGames from '@/components/SuperPass/superPassGames/SuperPassGames'
import SuperPassPasses from '@/components/SuperPass/superPassPasses/SuperPassPasses.vue'
import SuperPassPurchase from '@/components/SuperPass/superPassPurchase/SuperPassPurchase.vue'
import SuperPassPaymentMethod from '@/components/SuperPass/superPassPaymentMethod/SuperPassPaymentMethod.vue'
import GiftPaymentMethod from '@/components/Gift/GiftPaymentMethod/GiftPaymentMethod.vue'
import SuperPassTimeInfo from '@/components/SuperPass/superPassTimeInfo/SuperPassTimeInfo.vue'
import SuperPassStockInfo from '@/components/SuperPass/superPassStockInfo/SuperPassStockInfo.vue'
import PacksPayment from '@/components/Packs/PacksPayment/PacksPayment.vue'

import { mapMutations } from 'vuex'
import { PURCHASE_METHODS } from '@/utils/purchase'
import stepBackButton from '@/mixins/stepBackButton'

// Шаги, на которые «Назад» возвращать можно (RBXGD-1110).
//
// Сюда входят и выбор платёжки, и сводка заказа: порядок такой —
//
//   ввод данных → выбор платёжки → сводка заказа → заказ создан
//
// то есть оба они ДО списания, и человек вправе вернуться со сводки, чтобы
// сменить способ оплаты. Точка невозврата одна — создание заказа, она в
// FINAL_STEPS ниже.
//
// Не входят только авторизация и экраны созданного заказа: возвращаться в
// форму входа после успешного входа или в сводку оплаченного заказа незачем.
// SuperPassPurchase сюда НЕ входит, хотя выглядит шагом. Его created() зовёт
// checkBalanceAndRedirect(), и при нехватке баланса компонент сразу эмитит
// переход на оплату. Возврат на такой шаг мгновенно отбрасывал обратно вперёд,
// и «Назад» с оплаты на суперпассе внешне не работал вовсе. Это транзитный
// шлюз, а не экран, на котором человек что-то делает.
const RESTORABLE_STEPS = [
  'MainForm',
  'SuperPassGames',
  'SuperPassPasses',
  'SuperPassTimeInfo',
  'SuperPassStockInfo',
  'TransferCharacters',
  'TransferPrivatPlace',
  'TransferInstructionGamepass',
  'PacksPayment',
  'TransferPaymentMethod',
  'GiftPaymentMethod',
  'OrderConfirmation'
]

// Дошли до этих — заказ оформлен, назад по шагам уже некуда.
const FINAL_STEPS = ['TransferApproved', 'TransferOrderSuccesful']

// Шаги, за которыми стоит компонент оплаты. Он рисует не один экран, а два:
// выбор платёжного метода и «Проверьте данные» — см. миксин paymentSubStep.
// Для currentTransfer это один шаг, поэтому экран приходит отдельно, в
// paymentSubStep, и попадает в токен: у двух остановок навигации должны быть
// две записи в истории, иначе «Назад» с проверки данных перепрыгивает выбор
// метода. Суперпасс отдельным шагом не числится — его компонент оплаты
// нарисован под тем же именем TransferPaymentMethod.
const PAYMENT_STEPS = ['TransferPaymentMethod', 'GiftPaymentMethod', 'PacksPayment']

// Номера экранов внутри компонента оплаты. Совпадают у всех четырёх витрин: у
// паков это STEP.METHODS и STEP.CHECKOUT, у остальных просто 1 и 2. Экран
// оплаты с баланса (у паков он нулевой) своего токена не получает — это
// развилка по балансу, а не остановка навигации.
const METHODS_SUB_STEP = 1
const CHECKOUT_SUB_STEP = 2

// Что попадает в адрес вместо внутренних имён шагов. Имена в коде исторические
// и врут: шаг оплаты называется TransferPaymentMethod на всех витринах, включая
// суперпасс, — и пользователь видел в адрес «transfer», стоя на суперпассе.
// Слаги короткие и описывают сам шаг, а не компонент, который его рисует.
const STEP_SLUGS = {
  // MainForm здесь намеренно нет: на трансфере, гифтах и паках это базовый шаг
  // с пустым токеном, а на суперпассе он вообще не рисуется — там базовый шаг
  // SuperPassGames. В currentTransfer он на суперпассе всё же мелькает, пока
  // created разбирает роут, и слаг сделал бы из этого мусорную запись в истории.
  SuperPassGames: 'games',
  SuperPassPasses: 'passes',
  SuperPassPurchase: 'pass',
  SuperPassTimeInfo: 'time',
  SuperPassStockInfo: 'stock',
  TransferCharacters: 'nickname',
  TransferPrivatPlace: 'place',
  TransferInstructionGamepass: 'gamepass',
  PacksPayment: 'pack',
  TransferPaymentMethod: 'payment',
  GiftPaymentMethod: 'payment',
  OrderConfirmation: 'confirm',
  SignIn: 'signin',
  SignUp: 'signup',
  TransferApproved: 'done',
  TransferOrderSuccesful: 'done'
}

// Обратное соответствие. Слаг payment и done принадлежат двум шагам каждый,
// поэтому разворачиваем по фактическому методу — см. stepFromSlug.
const slugToSteps = Object.entries(STEP_SLUGS).reduce((acc, [step, slug]) => {
  acc[slug] = acc[slug] || []
  acc[slug].push(step)

  return acc
}, {})

export default {
  name: 'Transfer',
  mixins: [stepBackButton],
  components: {
    SuperPassStockInfo,
    SuperPassTimeInfo,
    SuperPassPurchase,
    PacksPayment,
    SuperPassPaymentMethod,
    GiftPaymentMethod,
    SuperPassPasses,
    Navigation,
    TransferMainForm,
    TransferCharacters,
    TransferPrivatPlace,
    TransferInstructionGamepass,
    OrderConfirmation,
    TransferPaymentMethod,
    Approved,
    OrderSuccesful,
    Loader,
    SignIn,
    SignUp,
    SuperPassGames
  },
  data() {
    return {
      currentTransfer: 'MainForm',
      data: {
        totalRobux: '',
        moneyTotal: '',
        robloxUserId: '',
        nickname: '',
        placeId: '',
        placeName: '',
        orders: [],
        uid: '',
        method: 'gamepass',
        gift: {},
        superPass: false,
        packs: false,
        pack: {},
        game: {},
        pass: null
      },
      isGiftNoneAuth: false,
      // Экран внутри компонента оплаты, поднятый сюда из его currentStep, чтобы
      // попасть в токен шага. null — компонент оплаты не смонтирован либо ещё
      // не сообщил экран; сбрасывается его beforeDestroy, чтобы номер не утёк
      // в следующий заход на оплату.
      paymentSubStep: null,
      loading: true
    }
  },
  computed: {
    packWithNickname() {
      return { ...this.data.pack, nickname: this.data.nickname }
    },
    // Метод берём из роута (/superpass, /packs, /giftcards). Query оставлен
    // фолбэком: по таким ссылкам ещё ходят из рекламы и закупки.
    currentMethod() {
      if (this.$route.meta.method) return this.$route.meta.method

      const { gift, superPass, packs } = this.$route.query

      if (packs) return PURCHASE_METHODS.PACKS
      if (gift) return PURCHASE_METHODS.GIFT
      if (superPass) return PURCHASE_METHODS.SUPER_PASS

      return PURCHASE_METHODS.TRANSFER
    },
    // Один компонент обслуживает четыре витрины, а h1 был вшит строкой — на
    // трёх из них он врал, и все четыре отдавали роботу одинаковый заголовок.
    // Ключ приходит из роута, текст — из реестра SEO, тот же, что в пререндере.
    seoHeading() {
      return this.$t(this.$route.meta.h1Key || 'app.transfer.h1')
    },
    // Базовый шаг зависит от витрины: суперпасс начинается с выбора игры,
    // остальные — с формы. С него «Назад» уводит из флоу.
    baseStep() {
      return this.data.superPass ? 'SuperPassGames' : 'MainForm'
    },
    // Токен для истории (см. миксин stepBackButton). Пустой только у базового
    // шага: с него «Назад» уводит из флоу. Остальные шаги записываются все, в
    // том числе те, на которые возвращаться нельзя — их отфильтрует restoreStep.
    stepToken() {
      // Проверка данных нарисована внутри компонента оплаты, но это отдельная
      // остановка навигации — значит, и отдельная запись в истории.
      if (PAYMENT_STEPS.includes(this.currentTransfer) && this.paymentSubStep === CHECKOUT_SUB_STEP) {
        return 'checkout'
      }

      if (this.currentTransfer === this.baseStep) return ''

      return STEP_SLUGS[this.currentTransfer] || this.currentTransfer
    },
    // Компонент оплаты у каждой витрины свой, а слаги payment и checkout общие,
    // поэтому разворачиваем их по фактической витрине.
    paymentStep() {
      if (this.currentMethod === PURCHASE_METHODS.GIFT) return 'GiftPaymentMethod'
      if (this.currentMethod === PURCHASE_METHODS.PACKS) return 'PacksPayment'

      return 'TransferPaymentMethod'
    }
  },
  beforeDestroy() {
    this.$store.commit('setPromoBonus', null)
  },
  created() {
    const requestHeaders = new Headers({
      Authorization: `Bearer ${this.$cookies.get('access_token')}`
    })

    const requestParams = {
      method: 'GET',
      headers: requestHeaders
    }

    this.loading = true

    fetch('https://transfer.backend-pier.com/active_orders', requestParams)
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          this.data.orders = data.orders

          if (this.data.orders.length > 0) {
            // Не отображать форму с активными заявками при повторных покупках
            // this.currentTransfer = 'TransferOrderSuccesful'
          }
        }
      })
      .catch(err => console.log(err))
      .finally((this.loading = false))
  },
  watch: {
    // Витрины теперь различаются путём, а не query, поэтому следим за роутом
    // целиком — иначе переход /superpass → /packs не переключал бы метод.
    $route: {
      handler(to, from) {
        // Возврат по шагу меняет только hash: его пишет наш же механизм «Назад»
        // (миксин stepBackButton). Роутер в режиме history пере-резолвит такой
        // URL как смену роута, и без этой проверки checkGetParams сбрасывал бы
        // флоу на первый шаг — то есть кнопка «Назад» выкидывала бы в начало,
        // ровно та беда, которую задача и чинит (RBXGD-1110).
        if (from && to.path === from.path && to.fullPath.split('#')[0] === from.fullPath.split('#')[0]) return

        this.checkGetParams()
        this.$store.commit('setPromoBonus', null)
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['setPurchaseMethod']),

    // Слаг из адреса обратно в имя шага. Слаг payment носят два шага —
    // гифтовый и общий, — поэтому выбираем по витрине. Слаг done тоже общий, но
    // восстанавливать его не придётся: FINAL_STEPS всё равно уводят на базовый.
    stepFromSlug(slug) {
      if (slug === 'payment' || slug === 'checkout') return this.paymentStep

      return (slugToSteps[slug] || [])[0]
    },

    // Вызывается миксином, когда браузер отдал предыдущий шаг из истории.
    // Здесь и только здесь решается, куда «Назад» пускать.
    restoreStep(slug) {
      const token = slug ? this.stepFromSlug(slug) : ''
      // Заказ уже оформлен. В истории остались записи предыдущих шагов, и без
      // этой ветки «Назад» с экрана успешной покупки вернул бы в сводку
      // оплаченного заказа. Убрать те записи нельзя — History API этого не
      // умеет, — поэтому просто не пускаем в них.
      if (FINAL_STEPS.includes(this.currentTransfer)) {
        this.currentTransfer = this.baseStep
        // Иначе в адресе останется токен шага, с которого мы не пустили назад,
        // и URL будет противоречить тому, что на экране.
        this.clearStepHash()
        return
      }

      if (!token) {
        this.currentTransfer = this.baseStep
        return
      }

      // Шаг, на который возвращаться незачем: авторизация и экраны созданного
      // заказа. Проматываем историю дальше назад, а не останавливаемся здесь —
      // иначе нажатие «Назад» внешне не сделает ничего.
      if (!RESTORABLE_STEPS.includes(token)) {
        window.history.back()
        return
      }

      // Внутри шага оплаты «Назад» переключает экран компонента, а сам шаг не
      // меняется. Без этого присваивание currentTransfer ниже оказалось бы
      // пустой операцией: адрес показывал бы выбор метода, а на экране осталась
      // бы проверка данных.
      if (PAYMENT_STEPS.includes(token)) {
        const наПроверку = slug === 'checkout'

        // Компонент оплаты подняли заново — проверять в нём нечего: метод не
        // выбран, суммы не посчитаны. Проматываем историю дальше назад.
        if (наПроверку && this.currentTransfer !== token) {
          window.history.back()
          return
        }

        this.paymentSubStep = наПроверку ? CHECKOUT_SUB_STEP : METHODS_SUB_STEP
      }

      this.currentTransfer = token
    },

    checkGetParams() {
      const method = this.currentMethod

      this.setPurchaseMethod(method)

      this.data.superPass = method === PURCHASE_METHODS.SUPER_PASS
      this.data.packs = method === PURCHASE_METHODS.PACKS
      this.currentTransfer = this.data.superPass ? 'SuperPassGames' : 'MainForm'
    },
    changeTransfer(params) {
      this.isGiftNoneAuth = false

      if (this.currentTransfer === 'MainForm') {
        // Очистка методов
        this.data.gift = {}
        this.data.superPass = false

        this.data.totalRobux = params.data[0]
        this.data.moneyTotal = params.data[1]
        this.data.promo = params.data[2]
        this.data.bonus = params.data[3]
        this.data.bonusForGamepass = params.data[4]

        // Сохраняем промокод и бонус в store
        this.$store.commit('paymentsOrder/setPromoCode', params.data[2])
        this.$store.commit('setPromoBonus', params.data[3])

        // Очищаем флаг SuperPass в store для обычного Transfer
        this.$store.commit('paymentsOrder/setSuperPassData', {
          isSuperPass: false,
          superPassId: ''
        })
      } else if (this.currentTransfer === 'TransferCharacters') {
        this.data.robloxUserId = params.data[0]
        this.data.nickname = params.data[1]

        if (!this.$store.state.isAuth && (this.data.superPass || this.data.packs)) {
          this.currentTransfer = 'SignIn'
          return
        }
      } else if (this.currentTransfer === 'TransferPrivatPlace' && params.data) {
        this.data.placeId = params.data[0]
        this.data.placeName = params.data[1]
        this.data.uid = params.data[2]
      } else if (this.currentTransfer === 'TransferApproved' && params.data) {
        this.data.orders.unshift(params.data[0])
      } else if (this.currentTransfer === 'SuperPassGames' && params.game) {
        this.data.game = params.game
      } else if (this.currentTransfer === 'SuperPassPasses' && params.pass) {
        this.data.pass = params.pass
      }

      this.currentTransfer = params.modal
    },
    submitGift(gift) {
      if (gift.modal) {
        this.isGiftNoneAuth = true
        this.currentTransfer = gift.modal
        return
      }

      this.data.gift = gift

      if (gift.needPayment) {
        this.currentTransfer = 'GiftPaymentMethod'
        return
      }

      this.currentTransfer = 'OrderConfirmation'
    },
    submitPack(pack) {
      this.data.pack = pack
      this.data.packs = true
      this.currentTransfer = 'TransferCharacters'
    },
    // submitSuperPass(params) {
    //   this.data.superPass = true
    //   this.currentTransfer = params.modal
    // },
    signInBack() {
      if (this.isGiftNoneAuth) {
        this.currentTransfer = 'MainForm'
        return
      }
      if (this.data.superPass || this.data.packs) {
        this.currentTransfer = 'TransferCharacters'
        return
      }
      // При возврате из модалки авторизации возвращаемся на выбор плейса
      this.currentTransfer = 'TransferPrivatPlace'
    },
    signInSuccess() {
      if (this.isGiftNoneAuth) {
        this.currentTransfer = 'MainForm'
        return
      }
      // Ждем обновления store после авторизации
      // В SignIn.vue emit('success') вызывается ДО dispatch('signIn')
      this.$nextTick(() => {
        if (this.data.packs) {
          this.currentTransfer = 'PacksPayment'
          return
        }
        if (this.data.superPass) {
          // Для SuperPass переходим на страницу покупки, где будет проверка баланса
          this.currentTransfer = 'SuperPassPurchase'
          return
        }

        this.currentTransfer = 'TransferInstructionGamepass'
      })
    }
  }
}
</script>

<style lang="scss">
@import './transfer';
</style>
